// extracted by mini-css-extract-plugin
export default {"selectionWrapper":"SatisfactorySurvey_selectionWrapper__ubzGi"};